import React from "react";
import { Button } from "@material-ui/core";

export type InputElement = React.DetailedHTMLProps<
React.InputHTMLAttributes<HTMLInputElement>,
HTMLInputElement
>;

const FileUploadButton = (props: InputElement) => (
  <label htmlFor="upload">
    <input style={{ display: "none" }} type="file" {...props} />
    <Button color="primary" variant="contained" component="span">
        Select Files
    </Button>
  </label>
);

export default FileUploadButton;
